import { makeIcon } from './makeIcon';

const matrix = [
  [0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0],
  [0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0],
  [2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2],
  [2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 2, 2],
  [2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 2, 2],
  [2, 2, 0, 0, 0, 0, 2, 2, 2, 2, 0, 0, 0, 0, 2, 2],
  [3, 2, 0, 0, 0, 2, 0, 0, 0, 0, 2, 0, 0, 0, 2, 3],
  [3, 3, 0, 0, 0, 2, 0, 0, 0, 0, 2, 0, 0, 0, 3, 3],
  [3, 3, 0, 0, 0, 3, 0, 0, 0, 0, 3, 0, 0, 0, 3, 3],
  [3, 3, 0, 0, 0, 3, 0, 0, 0, 0, 3, 0, 0, 0, 3, 3],
  [4, 4, 0, 0, 0, 0, 3, 3, 3, 3, 0, 0, 0, 0, 3, 3],
  [4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3],
  [4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 5],
  [4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 5],
  [0, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 0],
  [0, 0, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 0, 0]
];
const colors = ['#fff', '#8005c8', '#d40075', '#e98c25', '#d84646'];

export default makeIcon(matrix, colors);
